<template>
  <div class="services">
    <div class="text-center pb-5">
      <h3>Перечень услуг</h3>
    </div>
    <div class="row">
      <div class="col-lg-4 card-deck">
        <div class="card border-secondary mb-3">
          <div class="card-header font-weight-bold">Тариф 490</div>
          <div class="card-body">
            <h5 class="card-title">Что включено в тариф:</h5>
            <p class="card-text">- начальная настройка оборудования</p>
            <p class="card-text">- поддержка по email, ответ в течении 24 часов</p>
          </div>
          <div class="card-footer">
            <h5 class="card-title">Цена: 490 руб./мес.</h5>
            <small class="text-muted">Последнее обновление 20 марта 2020 г.</small>
          </div>
        </div>
      </div>
      <div class="col-lg-4 card-deck">
        <div class="card border-secondary mb-3">
          <div class="card-header font-weight-bold">Тариф 690</div>
          <div class="card-body">
            <h5 class="card-title">Что включено в тариф:</h5>
            <p class="card-text">- начальная настройка оборудования</p>
            <p class="card-text">- удаленная поддержка оборудования</p>
            <p class="card-text">- поддержка по email, ответ в течении 24 часов</p>
            <p class="card-text">- поддержка по телефону</p>
          </div>
          <div class="card-footer">
            <h5 class="card-title">Цена: 690 руб./мес.</h5>
            <small class="text-muted">Последнее обновление 20 марта 2020 г.</small>
          </div>
        </div>
      </div>
      <div class="col-lg-4 card-deck">
        <div class="card border-secondary mb-3">
          <div class="card-header font-weight-bold">Тариф 990</div>
          <div class="card-body">
            <h5 class="card-title">Что включено в тариф:</h5>
            <p class="card-text">- начальная настройка оборудования</p>
            <p class="card-text">- удаленная поддержка оборудования</p>
            <p class="card-text">- поддержка по email, ответ в течении 24 часов</p>
            <p class="card-text">- поддержка по телефону</p>
            <p class="card-text">- до 1 выезда к заказчику в месяц</p>
          </div>
          <div class="card-footer">
            <h5 class="card-title">Цена: 990 руб./мес.</h5>
            <small class="text-muted">Последнее обновление 20 марта 2020 г.</small>
          </div>
        </div>
      </div>
      <div class="py-3 text-muted">
        <sup><small>*</small></sup>
        Начальная(базовая) настройка оборудования включает в себя установку и настройку антен,
        усилителя связи, роутера и дополнительных устройств заказчика, необходимыых для
        обеспечения качественного и бесперебойного доступа к сетям передачи данных.
      </div>
      <div class="pb-3 text-muted">
        <sup><small>**</small></sup>
        Поддержка и консалтинг(деятельность по консультированию руководителей,
        управленцев по вопросоам в сфере построения и обслуживания сетей передачи данных)
        осуществляется Исполнителем удаленно(электронная почта, телефонные консультации) или
        непосредственно на територии Заказчика, в зависимости от актуального тарифа заказика.
      </div>
      <div class="pb-5 text-muted">
        <sup><small>***</small></sup>
        Исполнитель имеет право в любой момент изменять стоимость и состав тарифов
        в одностороннем порядке без предварительного согласования с Заказчиком,
        обеспечивая при этом публикацию измененных условий на этой странице,
        не менее чем за один день до их ввода в действие.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Services',
};
</script>
